<template>
<div>
    <div class="form-container ou-donation-form ja-ou-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <section class="ja__header" v-show="!subscriptionType">
                    <h3>Subscribe to Jewish Action</h3>
                    <p>
                      Who is this subscription for?
                    </p>
                  <div class="ja__header__actions">
                      <div class="ja__header__link" :class="{ active: subscriptionType === 'self' }" id="self" @click="selectSelf">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M31.6125 4.75547V4.73906C31.6 4.44141 31.5406 4.15078 31.4281 3.86719C30.325 4.17031 29.2453 4.54688 28.1945 4.98828C28.1922 4.97188 28.1898 4.95547 28.1891 4.93906C28.1906 4.95547 28.1914 4.97266 28.1922 4.98906C24.0383 6.73359 20.3312 9.50625 17.3875 12.9383C14.4414 16.4359 11.8797 20.9023 12.207 25.6602C12.2367 26.2367 12.4961 26.7898 12.9016 27.1992L8.38281 33.6008H8.46875C8.45312 33.6031 8.4375 33.6055 8.42187 33.6078C9.59219 33.7984 10.775 33.8906 11.957 33.9547C12.3906 33.9742 12.8336 33.9578 13.2531 33.9984C12.9648 34.1047 12.6547 34.1828 12.357 34.2563L11.893 34.3742C11.7422 34.4219 11.6188 34.5016 11.482 34.6172C11.1203 34.9242 11.0547 35.4625 11.4055 35.8266C11.6555 36.0883 12.0297 36.1359 12.3492 36.132C13.982 36.0547 17.7477 35.7008 17.7477 35.7008L17.7531 35.3578C17.7531 35.3578 15.2062 35.3422 13.975 35.3031C13.6133 35.2914 13.2508 35.2836 12.8805 35.2844C12.6039 35.2719 12.2875 35.332 12.0609 35.2555C12.0844 35.2367 12.1125 35.2172 12.1437 35.2008C12.8469 35.0297 13.6883 34.8438 14.1945 34.4633C14.4156 34.2773 14.5344 33.9391 14.4 33.657C14.1953 33.3023 13.7555 33.2469 13.407 33.2141C12.9594 33.1789 12.3992 33.232 11.9562 33.2477C10.8359 33.3125 9.71641 33.4047 8.60625 33.5797L10.9078 32.0992L10.943 31.4508L13.4953 27.6344C13.5094 27.6414 13.5234 27.65 13.5375 27.657C13.957 27.868 14.4531 27.9453 14.9156 27.8922C15.2617 27.8695 15.6141 27.825 15.9555 27.768C18.8211 27.2484 21.3648 25.6398 23.4711 23.6867C28.3766 19.0859 31.5633 12.018 31.6172 5.275L31.6117 4.75469L31.6125 4.75547ZM13.8445 25.5609L13.8297 25.4656C13.4234 22.382 14.5414 19.2922 16.0102 16.5992C16.9258 14.9859 18.0086 13.4594 19.2289 12.0477L20.1695 16.9063L13.9133 25.768C13.8789 25.7039 13.8547 25.6344 13.8445 25.5609ZM18.7797 24.5938C17.6117 25.3242 16.3242 25.8805 14.9641 26.0891C14.8727 26.0992 14.6633 26.1344 14.5805 26.1414C14.5523 26.1438 14.5234 26.1438 14.4953 26.1422L16.8086 22.6828L21.6687 22.2484C20.7812 23.1414 19.8164 23.9328 18.7797 24.5938ZM28.1719 7.97422C27.7437 12.7547 25.6156 17.9539 22.2273 21.6641L17.5453 21.582L25.1414 10.2242H24.8875L20.8906 15.8859L19.6211 11.6039C22.0406 8.91953 24.9672 6.67813 28.1992 5.09141C28.2648 6.04766 28.257 7.01719 28.1719 7.97422Z" fill="#0E1622"/><path d="M28.1875 4.91607C28.1875 4.90534 28.1875 4.91855 28.1875 4.93011C28.1875 4.93423 28.1883 4.93754 28.1891 4.94166C28.1891 4.93754 28.1891 4.93423 28.1891 4.93011V4.91607H28.1875Z" fill="#0E1622"/></svg>
                        <span>For Myself</span>
                      </div>
                      <div class="ja__header__link" :class="{ active: subscriptionType === 'gift' }" id="gift" @click="selectGift">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M33.875 15.9046H30.2063L24.8594 15.8249C24.2102 15.3624 23.3328 15.1186 22.3445 15.1265C23.6398 14.9593 26.55 15.0022 28.6797 13.689C32.3797 11.4077 31.8406 6.2288 27.9203 4.61942C25.1133 3.46786 21.9039 5.01317 20.8516 7.82255C20.7602 8.06005 20.6828 8.31864 20.6234 8.56552C20.3336 9.66864 20.0281 11.1452 19.7422 12.603C19.4563 11.146 19.1508 9.66942 18.8609 8.56552C18.8016 8.31864 18.7242 8.06005 18.6328 7.82255C17.5805 5.01317 14.3703 3.46786 11.5641 4.61942C7.64375 6.2288 7.10469 11.4069 10.8047 13.689C12.9344 15.0022 15.8445 14.9593 17.1398 15.1265C15.8492 14.8265 8.27344 12.939 9.80547 9.26239C10.3266 8.01239 11.5773 7.33114 12.9359 7.27333C14.4539 7.17255 15.9078 8.85849 16.275 10.3218C16.3047 10.439 16.5922 11.4327 16.7 12.239C16.8687 13.4843 17.0172 13.9468 17.1391 15.1272C16.2461 15.1257 15.4445 15.3311 14.8234 15.7186H6.125V35.7569H9.74375V35.7655H33.793V35.7569H33.8758V15.9054L33.875 15.9046ZM30.2102 35.4296L20.5672 35.4069L19.9234 20.2507L22.9539 20.3515C23.132 21.0913 23.2602 21.6194 23.2602 21.6194L26.6711 21.1632C26.6711 21.1632 26.6086 20.8897 26.5086 20.4694L30.2063 20.5929V28.7952C30.2063 29.403 30.2188 34.1046 30.2102 35.4296ZM20.6383 16.1905H21.9781C22.1484 16.9741 22.5336 18.5944 22.8375 19.8624H16.6867C16.9906 18.5944 17.375 16.9741 17.5461 16.1905H20.6391H20.6383ZM30.2063 19.8624H26.3625C26.0414 18.5475 25.5492 16.6475 25.2813 16.1905H30.2063V19.8624ZM23.2094 10.321C23.5766 8.85849 25.0305 7.17255 26.5484 7.27255C27.907 7.33036 29.1578 8.01239 29.6789 9.26161C31.2109 12.9374 23.6352 14.8257 22.3445 15.1257C22.4664 13.9452 22.6148 13.4827 22.7836 12.2374C22.8914 11.4311 23.1789 10.4374 23.2086 10.3202L23.2094 10.321ZM9.78437 16.1905H14.2414C13.9742 16.6483 13.482 18.5483 13.1602 19.8624H9.78437V16.1905ZM13.1211 20.0241C12.9602 20.6858 12.8516 21.164 12.8516 21.164L16.2625 21.6202C16.2625 21.6202 16.4156 20.9897 16.6195 20.1405L19.6219 20.2405L19.5914 29.4015C19.5914 29.9679 19.4531 34.5874 19.4242 35.396C16.9063 35.3624 10.4734 35.253 9.78516 35.2358V19.9124L13.1219 20.0233L13.1211 20.0241Z" fill="#0E1622"/></svg>
                        <span>Someone Else</span>
                      </div>              
                  </div>
                </section>   
                <div class="jasubscribe__content" v-show="subscriptionType">

                <div class="jasubscribe__backs">
                

                  <div class="jasubscribe__back__col" id="jrecipient" v-show="subscriptionType === 'gift'" @click="resetSelection">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5 23L15.5 18L20.5 13" stroke="#0E1622" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <span>Give the gift of a subscription to Jewish Action</span>
                  </div>    
                  <div class="jasubscribe__back__col" id="jself" v-show="subscriptionType === 'self'" @click="resetSelection">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5 23L15.5 18L20.5 13" stroke="#0E1622" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    <span>Subscribe to Jewish Action</span>
                  </div>                                
                </div>
                <JaAmountSelector />

                <FormSection title="Your Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 
                    <DonorAddress />

                </FormSection>  
<div class="ja-gift" id="giftreceipt" v-show="subscriptionType === 'gift'">
                <FormSection title="Recipient's Information">
                      <div class="ja-gift-container">
                        <FormRow inline>
                          <FormCol :flex="2" field="custom.recipientFirstName" />
                          <FormCol :flex="2" field="custom.recipientLastName" />
                        </FormRow>
                        <FormRow inline>
                          <FormCol field="custom.recipientStreet" :flex="2" />
                          <FormCol field="custom.recipientStreet2" :flex="2" />
                        </FormRow>
                        <FormRow inline>
                          <FormCol field="custom.recipientCountry" :flex="1"><CountrySelector /></FormCol>
                          <FormCol field="custom.recipientCity" :flex="1" />
                          <FormCol field="custom.recipientState" :flex="1"
                            ><StateSelector :country="getValue('custom.recipientCountry')"
                          /></FormCol>
                          <FormCol field="custom.recipientZip" :flex="1" />
                        </FormRow>
                        <FormRow inline>
                          <FormCol field="custom.recipientEmail" />
                          <FormCol field="custom.recipientPhone" />
                        </FormRow>
                      </div>
                    </FormSection>
                                      </div>


                    <div class="total__section__con" v-if="form.amount">   
                  <div class="total__section">
                      <strong>Total</strong>
                      <div class="total__section__opt">
                        <span v-if="getValue('custom.Notes')">{{ getValue('custom.Notes') }}</span>
                        <strong><MoneyFormat
                        class="amount"
                        :value="tamount"
                        :currencyCode="form.currency"
                      /></strong>
                    </div>
                  </div>
                </div> 
  
                <FormSection title="Payment Details">
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>             
                </FormSection>                
                <FormSection title="" last>
                    <FormRow>
                      <FormLabel class="control-label">
                        <div style="padding-bottom:7px;">How did you hear about us?</div>
        
          <FormSelect field="custom.hearAboutUs" style="flex: 1; margin-right: 10px">
            <option :value="null">Select an option</option>
            <option value="instagram">Instagram</option>
            <option value="facebook">Facebook</option>
            <option value="x">X (Twitter)</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="tiktok">TikTok</option>
            <option value="google">Google</option>
            <option value="print-magazine">Print Magazine</option>
            <option value="friend">Friend</option>
            <option value="family-member">Family Member</option>
            <option value="other">Other</option>
          </FormSelect>
        </FormLabel>
        </FormRow>
        <ErrorLabel field="custom.hearAboutUs" />                
                  <FormRow>
                      <NewsletterSubscribe text="Sign me up for Jewish Action’s monthly newsletter" />
                </FormRow>    
                </FormSection>
                    <PaymentButton :showAmount="false" btnText="Subscribe to Jewish Action Magazine"/>
                    </div>         
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import { usePaymentForm } from '~/shared/use-payment-form'
import JaAmountSelector from './components/amount-selector.vue'
import { queryParams } from "~/shared/query-params";

export default defineComponent({
      components: {
    JaAmountSelector,
  },
  setup(props) {
    const { getValue, setValue, form } = usePaymentForm();
    

    const params = queryParams();


    // Track subscription type: null (initial), 'self', or 'gift'
    const subscriptionType = ref<string | null>(null);

    const selectSelf = () => {
      subscriptionType.value = 'self';
      setValue('custom.isGift', 'false');
    };

    const selectGift = () => {
      subscriptionType.value = 'gift';
      setValue('custom.isGift', 'true');
    };

    // Check for subscriptionType query parameter on load
    if (params.subscriptionType) {
      //@ts-ignore
      if (params.subscriptionType === 'self') {
        selectSelf();
      } else if (params.subscriptionType === 'gift') {
        selectGift();
      }
    }

    const resetSelection = () => {
      subscriptionType.value = null;
    };

    const tamount = computed(() => {
      //@ts-ignore
      let calculatedAmount = ['wire', 'check'].includes(form.value.gateway)
      ? +form.value.amount!
      : form.value.handleProcessing
        ? Math.round((+form.value.amount! + +form.value.amount! * 0.025) * 100) / 100
        : +form.value.amount!;
      
      if (form.value.periodMonths && form.value.dayOfMonth) {
      calculatedAmount *= +form.value.periodMonths;
      }

      return calculatedAmount;
    });
    return {
      form,
      tamount,
      getValue,
      setValue,
      subscriptionType,
      selectSelf,
      selectGift,
      resetSelection,
    }
  },
})
</script>
<style scoped lang="scss">

::v-deep h2 {
color: var(--Grayscale-Ash, #0E1622);
margin-top: 0px;
margin-bottom: 16px;
font-family: "Oswald";
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 18px; /* 112.5% */
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
label,
::v-deep label {
  font-size: .85em;
  color: #333;
}

.form-container.ou-donation-form.ja-ou-form{
    margin: 10px auto 0px !important;
    box-shadow: none !important;
}
.subscribe__btn {
    display: flex;
    background: #1DA1F2;
    color: white;
    margin-bottom: 20px;
    align-items: center;
    padding: 8px 12px;
    border-radius: 6px;
    font-weight: 600;
    gap: 7px;
    cursor:pointer;
    transition: all 0.3s ease-in-out;
    justify-content: center;
}
.subscribe__btn:hover{
      background: #004c7b;
    }
.subscribe__btn svg {
    height: 28px;
}
.subscribe__btn.checked{
      background: #f2f6fd;
    color: #595c5f;
    }

.subscribe__btn.checked svg {
    fill: #595c5f !important;
}

.total__section {
    display: flex;
    max-width: 100%;
    padding: 16px;
    flex-flow: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    border-radius: 2px;
    background: var(--Secondary-Light, #FFF9ED);
}

.total__section strong {
    color: var(--Grayscale-Ash, #0E1622);

/* Desktop/Headline/H7 */
    font-family: "Oswald";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 128.571% */
}

.total__section__opt {
    color: var(--Secondary-Default, #BD8E5C);
    display: flex;
    gap: 8px;
    align-items: center;
/* Desktop/Text/Label */
    font-family: "Merriweather";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
}

.ja-gift {
  margin-top: 20px;
      padding-top: 12px;
  margin-bottom: 20px;
}
.ja-gift-container {
  margin-top: 30px;
}

.total__section__con {
    margin-top: 20px;
    margin-bottom: 30px;
}


.ja__header {
h3{
  color: var(--Grayscale-Ash, #0E1622);
font-family: "Oswald";
font-size: 24px;
text-align: center;
font-style: normal;
font-weight: 600;
margin-bottom: 12px;
line-height: 32px; /* 133.333% */
	  @media only screen and (min-width: 720px) {
margin-bottom: 32px;
    }
}
p{
  color: var(--Grayscale-Label, #464749);
text-align: center;
font-family: "Merriweather";
font-size: 14px;
font-style: normal;
margin-bottom: 8px;
font-weight: 400;
line-height: 20px; /* 142.857% */
}
}
.ja__header__actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}
.ja__header__link {
  display: flex;
padding: 10px 12px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 8px;
flex-shrink: 0;
border-radius: 2px;
border: 2px solid var(--Grayscale-Input, #EBEBEB);
background: var(--White, #FFF);
cursor: pointer;
transition: all 0.3s ease-in-out;
	  @media only screen and (max-width: 720px) {
      flex: 1;
    }
	  @media only screen and (min-width: 720px) {
   padding: 20px 24px;   
width: 215px;
height: 102px;
    }
span{
  color: var(--Grayscale-Ash, #080F16);
text-align: center;
display: block;
font-family: "Oswald";
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 26px; /* 130% */
}
&:hover {
  border-radius: 2px;
border: 2px solid var(--Grayscale-Line, #CFD1D3);
background: var(--White, #FFF);
}
&.active {
border-radius: 2px;
border: 2px solid var(--Primary-Default, #1E50B4);
background: var(--White, #FFF);
span{
  color: var(--Primary-Default, #1E50B4);
}
}
}


.jasubscribe__back__col{
  display: flex;
align-items: center;
gap: 2px;
cursor: pointer;
span{
  color: var(--Grayscale-Ash, #0E1622);
display: block;
font-family: "Oswald";
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 28px; /* 133.333% */

    @media only screen and (min-width: 720px) {
font-size: 24px;
font-style: normal;
font-weight: 600;
line-height: 32px;
    }
}
&:hover {
  opacity: 0.7;
  svg{
    background: rgba(0, 0, 0, 0.05);
    fill: rgba(0, 0, 0, 0.05);
  }
}
}


.jasubscribe__backs{
  margin-bottom: 32px;
}
.jasubscribe__back__icon{
display: flex;
width: 36px;
height: 36px;
justify-content: center;
align-items: center;
flex-shrink: 0;
  
  &:hover{
    border-radius: 2px;
  background: rgba(0, 0, 0, 0.05);
  }
}

label{
  display: block;
}
input[type=checkbox], input[type=radio] {
    width: auto;
    height: auto;
    display: inline-block;
    opacity: 1;
    position: relative;
    line-height: normal;
}
</style>

